const externalStylesheetMixin = {
  data () {
    return {
      flatIconStylesheets: [
        {
          id: 'flatIconRegular',
          href: 'https://cdn-uicons.flaticon.com/uicons-regular-rounded/css/uicons-regular-rounded.css',
        },
        {
          id: 'flatIconSolid',
          href: 'https://cdn-uicons.flaticon.com/uicons-solid-rounded/css/uicons-solid-rounded.css',
        },
      ],
    };
  },
  methods: {
    constructStylesheetElement (id, href) {
      const link = document.createElement('link');
      link.id = id;
      link.href = href;
      link.rel = 'stylesheet';

      return link;
    },
    loadFlatIconStylesheets () {
      this.flatIconStylesheets.forEach(({ id, href }) => {
        if (!document.getElementById(id)) {
          const link = this.constructStylesheetElement(id, href);

          document.head.appendChild(link);
        }
      });
    },
    removeFlatIconStylesheets () {
      this.flatIconStylesheets.forEach(({ id }) => {
        const link = document.getElementById(id);

        if (link) {
          link.remove();
        }
      });
    },
  },
};

export default externalStylesheetMixin;



// WEBPACK FOOTER //
// ./src/common/mixins/externalStylesheet.js